<template>
    <footer class="footer">
        <div v-if="this.$route.name == 'send-shipment'" class="img-top">
            <img v-if="false" src="../../assets/images/City_Arabian.png" alt />
        </div>
        <div v-else class="footer-bottom">
            <div class="container">
                <div class="pay-methods">
                    <div class="level-item" id="payment-method">
                        <p style="width: 100%">{{ $t("Payment Methods") }}</p>
                        <div style="padding-top: 5px">
                            <figure class="image">
                                <img
                                    src="@/assets/images/mada.png"
                                    alt="mada"
                                    id="md-img"
                                />
                            </figure>
                            <figure class="image">
                                <img
                                    src="@/assets/images/visa.png"
                                    alt="visa"
                                    id="vi-img"
                                />
                            </figure>
                            <figure class="image">
                                <img
                                    src="@/assets/images/mastercard.png"
                                    alt="mastercard"
                                    id="ma-img"
                                />
                            </figure>
                            <figure class="image">
                                <img
                                    src="@/assets/images/logo.png"
                                    alt="ALKOON credit"
                                    id="bc-img"
                                />
                            </figure>
                        </div>
                    </div>
                </div>

                <div
                    class="level"
                    style="
                        padding: 10px 0 20px;
                        display: flex;
                        justify-content: center;
                    "
                >
                    <div
                        class="maroof"
                        style="flex-direction: column; text-align: center"
                    >
                        <div>
                            <figure class="image">
                                <a
                                    href="https://maroof.sa/164333"
                                    target="_blank"
                                >
                                    <img
                                        src="@/assets/images/maroof.png"
                                        alt="maroof logo"
                                        style="width: 100px"
                                    />
                                </a>
                            </figure>
                        </div>
                    </div>
                </div>
                <div style="text-align: center">
                    <p style="color: #777">
                        {{ $t("@2020 Alkon, All rights reserved") }}
                    </p>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
footer {
    .img-top {
        margin: -10px;
        opacity: 0.2;
    }

    padding: 0;
    position: relative;
    color: white;

    h1,
    h2,
    p {
        color: white;
    }

    a {
        display: inline-block;
        transition: 0.2s linear;
        color: white;

        &:hover {
            transform: translate(5px, 0px);
            font-weight: bold;
        }
    }

    .footer-bottom {
        margin-top: 100px;
        background: #f2f2f2;

        @media only screen and (max-width: 1050px) {
            padding: 0 15px;
        }
    }

    .content ul {
        margin-left: 0 !important;
        list-style-type: none;
    }

    #payment-method {
        flex-direction: column;

        figure {
            display: inline-block;
            height: 25px;
            width: 55px;
            margin-right: 5px;

            #bc-img {
                height: 15px;
                width: 45px;
            }

            #ap-img {
                height: 23px;
                width: 37px;
                margin-top: -5px;
            }

            #vi-img {
                height: 11px;
                width: 34px;
            }

            #ma-img {
                height: 23px;
                width: 28px;
                margin-top: -5px;
            }

            #md-img {
                height: 13px;
                width: 37px;
            }
        }
    }
}

.pay-methods {
    display: flex;
    justify-content: flex-start;
    border-bottom: 1px solid #aaa;

    p {
        // text-align: left;
        margin: 20px 0 10px;
        color: #777;
    }
}

.footer-social-icon {
    .is-medium {
        margin-right: 12px;
        margin-left: 12px;
        transition: 0.4s linear;
        color: #aaa;

        &:hover {
            color: #bbb;
            transform: translate(0px, -5px);
        }
    }
}
</style>
